import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { newBannerImgOne, productOfTheYear } from '../../assets/images/index'; 
import Breadcrumbs from '../../components/pageProps/Breadcrumbs'; 

const FeedbackForm = () => {
  const [formData, setFormData] = useState({
    fname: '',
    lname: '',
    email: '',
    serviceRating: '',
    harvelRating: '5',
    description: '',
    country: '',
    city: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    sessionStorage.setItem('feedbackData', JSON.stringify(formData));

   
    alert('Your feedback has been submitted. Thank you for your feedback!');
    
    
    setFormData({
      fname: '',
      lname: '',
      email: '',
      serviceRating: '',
      harvelRating: '5',
      description: '',
      country: '',
      city: '',
    });
  };

  return (
    <div className="container">
      
      <div
        className="relative w-100 h-[400px] bg-cover bg-center"
        style={{
          backgroundImage: `url(${productOfTheYear})`, 
        }}
      >
        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <h1 className="text-4xl font-bold text-white">Feedback</h1>
        </div>
      </div>

      
      <Breadcrumbs title="Feedback" prevLocation="Home" />

      <div className="row mt-5">
        <div className="col-md-6">
          <h1 style={{ fontSize: '40px', textAlign: 'center' }}><b>Feedback Form</b></h1>
          <form onSubmit={handleSubmit}>
            <div className="row mt-6 mb-6">
              <div className="col-md-6">
                <input
                  type="text"
                  name="fname"
                  value={formData.fname}
                  onChange={handleInputChange}
                  placeholder="First Name*"
                  className="form-control form-group"
                  required
                />
              </div>
              <div className="col-md-6">
                <input
                  type="text"
                  name="lname"
                  value={formData.lname}
                  onChange={handleInputChange}
                  placeholder="Last Name*"
                  className="form-control form-group"
                  required
                />
              </div>
            </div>

            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Username*"
              className="form-control form-group mb-6"
              required
            />
            
            <label>Our services*</label>
            <select
              name="serviceRating"
              value={formData.serviceRating}
              onChange={handleInputChange}
              className="form-control mb-6"
              required
            >
              <option value="" disabled>Select Environment</option>
              <option>Excellent</option>
              <option>Good</option>
              <option>Nice</option>
              <option>Bad</option>
              <option>Very Bad</option>
              <option>Other</option>
            </select>

            <label>How would you rate Harvel Electric (out of 5)?*</label>
            <select
              name="harvelRating"
              value={formData.harvelRating}
              onChange={handleInputChange}
              className="form-control mb-6"
              required
            >
              <option value="5">5</option>
              <option value="4">4</option>
              <option value="3">3</option>
              <option value="2">2</option>
              <option value="1">1</option>
            </select>

            <label>How would you rate Harvel Electric (Description)?</label>
            <input
              type="text"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              className="form-control mb-6"
              placeholder="Description"
              style={{ height: '60px' }}
              required
            />

            <label>What is your opinion about the country or city?</label>
            <div className="row mb-6">
              <div className="col-md-6">
                <select
                  name="country"
                  value={formData.country}
                  onChange={handleInputChange}
                  className="form-control"
                  required
                >
                  <option value="" disabled>Select Country</option>
                  <option>Pakistan</option>
                  <option>India</option>
                  <option>UAE</option>
                  <option>Iran</option>
                  <option>Others</option>
                </select>
              </div>

              <div className="col-md-6">
                <select
                  name="city"
                  value={formData.city}
                  onChange={handleInputChange}
                  className="form-control"
                  required
                >
                  <option value="" disabled>Select City</option>
                  <option>Karachi</option>
                  <option>Islamabad</option>
                  <option>Lahore</option>
                  <option>Others</option>
                </select>
              </div>
            </div>

            <button type="submit" className="btn btn-dark col-md-12 btn-block">Submit</button>
          </form>
        </div>
        
        <div className="col-md-6">
          <div className="position-relative">
            <img
              src={newBannerImgOne} 
              className="img-fluid"
              alt="Feedback"
              style={{ width: '100%', height: '650px', objectFit: 'cover' }}
            />
            <div 
              className="carousel-caption d-flex flex-column justify-content-center bg-black bg-opacity-10 align-items-center"
              style={{ top: '50%', transform: 'translateY(-50%)' }} 
            >
              <h1 className="text-white text-center" style={{ fontSize: '3rem' }}>The Providers</h1>
              <h3 className="text-white text-center" style={{ fontSize: '1.5rem' }}>
                We provide electric home appliances like Fans, AC, Geyser, Dispenser, Refrigerator, etc.
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedbackForm;
